import { LokaliseApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useLokaliseAPI(): LokaliseApi {
  return new LokaliseApi(apiConfig);
}
